<div
  class="cart-thank-you cart-thank-you__nomargin flex--column flex--nowrap flex__child--auto overflow-auto wrapper"
  *ngIf="cart$ | async as cart; else noCart"
>
  <div class="cart-thank-you__confirmation-text">
    <h1 class="text--h1">{{ 'cart-processing.order-received' | translate }}</h1>

    <ng-container *ngIf="(isAtLeastAdvisor$ | async) !== true">
      <p>{{ 'cart-processing.order-being-processed' | translate }}</p>
    </ng-container>
    <ng-container *ngIf="(isAtLeastAdvisor$ | async) === true">
      <p>{{ 'cart-processing.order-being-processed-advisor' | translate }}</p>

      <div class="cart-thank-you__quick-options-container">
        <button mat-flat-button color="primary" class="cart-thank-you__advisor-change-customer" routerLink="/" class="cart-thank-you__overview-link">
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'cart-processing.to-shop' | translate }}</span>
        </button>
        <button mat-button color="primary" class="cart-thank-you__advisor-change-customer" (click)="navigateToOverview(true)">
          <mat-icon>shopping_cart</mat-icon>
          <span>{{ 'cart-processing.new-customer-and-continue-shopping' | translate }}</span>
        </button>
      </div>
    </ng-container>
  </div>

  <div class="cart-thank-you__order-number spacing--margin-bottom">
    <div class="text--small text--gray spacing--padding-top">
      {{ 'cart-processing.order-numbers' | translate }}
    </div>
    <div class="spinner-container" *ngIf="isBeingProcessed$ | async">
      <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
      <span class="spinner-text blink-soft">{{ 'cart-processing.orderId-spinnerText' | translate }}</span>
    </div>
    <div *ngIf="cart?.orderMetadata?.orderNumbers?.length === 0 && (isBeingProcessed$ | async) !== true">
      <span>{{ 'cart-processing.no-order-numbers-available' | translate }}</span>
    </div>
    <div *ngIf="cart?.orderMetadata?.orderNumbers?.length && (isBeingProcessed$ | async) !== true">
      <span>{{ cart.orderMetadata.orderNumbers | join }}</span>
    </div>
  </div>

  <mat-divider class="cart-thank-you__divider"></mat-divider>

  <div *ngIf="cart?.type !== pickUpOrderType">
    <mat-card appearance="outlined" class="mat-elevation-z1 cart-thank-you__delivery-address spacing--margin-vertical" *ngIf="location$ | async">
      <mat-card-header>
        <div class="cart-thank-you__delivery-address-header" mat-card-header>
          <h3 *ngIf="cart?.type !== returnableOrderType" class="text--h5">{{ 'cart-processing.delivery-address' | translate }}</h3>
          <h3 *ngIf="cart?.type === returnableOrderType" class="text--h5">{{ 'cart-processing.return-address' | translate }}</h3>
        </div>
      </mat-card-header>
      <mat-card-content class="cart-thank-you__delivery-address-content">
        <ng-container>
          <ng-container *ngIf="(location$ | async) && (customer$ | async)">
            <agr-location-summary
              [location]="location$ | async"
              [customer]="customer$ | async"
              [showChangeLocation]="false"
              [altLocationSummaryAddressText]="
                cart?.type === returnableOrderType ? ('cart-processing.alt-location-summary-address-text' | translate) : undefined
              "
            ></agr-location-summary>
          </ng-container>

          <div class="spacing--margin-top flex" *ngIf="(isAtLeastAdvisor$ | async) !== true">
            <mat-card appearance="outlined" class="mat-elevation-z1">
              <mat-card-content class="cart-thank-you__delivery-address-note">
                <mat-icon>chat</mat-icon>
                <span class="spacing--padding-left">
                  {{ 'cart-processing.delivery-note' | translate }}
                </span>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-container>
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card appearance="outlined" class="mat-elevation-z1 cart-thank-you__products spacing--margin-vertical">
    <mat-card-header>
      <div class="cart-thank-you__products-header" mat-card-header>
        <h3 *ngIf="cart?.type !== returnableOrderType" class="text--h5">{{ 'cart-processing.we-will-deliver' | translate }}</h3>
        <h3 *ngIf="cart?.type === returnableOrderType" class="text--h5">{{ 'cart-processing.we-will-pickup' | translate }}</h3>
      </div>
    </mat-card-header>
    <mat-card-content>
      <div *ngIf="cart$ | async as cart; else noCart" class="spacing--margin-vertical">
        <app-cart [cart]="cart" [editable]="false"></app-cart>
      </div>

      <div class="flex--row">
        <div class="spacing--margin-vertical spacing--padding-right">
          <div class="text--small text--gray spacing--padding-top">
            {{ 'cart-processing.total-order-weight' | translate }}
          </div>
          <div class="text--large" *ngIf="cart?.orderMetadata?.weightInformation">
            {{ cart?.orderMetadata.weightInformation.weight | agrNumber }}
            {{ 'unit.' + cart.orderMetadata.weightInformation.unit | translate }}
          </div>
          <div class="spinner-container" *ngIf="!cart?.orderMetadata?.weightInformation">
            <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
            <span class="spinner-text blink-soft">{{ 'cart-processing.weight-spinnerText' | translate }}</span>
          </div>
        </div>

        <div class="spacing--margin-vertical spacing--padding-right">
          <app-total-ordered-weight [cart]="cart$ | async"></app-total-ordered-weight>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <div *ngIf="(isAtLeastAdvisor$ | async) === false && invoiceUrl$ | async as invoiceUrl">
    <h3 class="text--h5">{{ 'cart-processing.overview' | translate }}</h3>
    <div class="cart-thank-you__navbar">
      <div class="cart-thank-you__columns">
        <a [attr.href]="invoiceUrl" class="cart-thank-you__invoices-link">
          <mat-icon>assignment</mat-icon>
          <span class="spacing--padding-left">{{ 'cart-processing.to-invoices' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #noCart>
  <agr-notification-empty
    [isEmpty]="true"
    [emptyTitle]="'cart-processing.empty-title' | translate"
    [emptyDescription]="'cart-processing.empty-description' | translate"
    emptyActionColor="primary"
    [emptyActionText]="'cart-processing.continue-shopping' | translate"
    [showEmptyAction]="true"
    emptyActionIcon="shopping_cart"
    (emptyAction)="navigateToOverview(false)"
  >
  </agr-notification-empty>
</ng-template>
